import { m } from "framer-motion";
import React, { PropsWithChildren } from "react";

const AnimContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </m.div>
  );
};

export default AnimContainer;
